import { cn } from "@app/lib/utils";
import { URLS } from "@app/shared";
import { Link } from "@design-system/components";
import { useChangeLocaleCode } from "@design-system/hooks";
import { ArabicLogoIcon, LogoIcon } from "@design-system/icons";
import {
  LinksDrawerButton,
  MobileLinksDrawer,
  SearchDrawer,
} from "@design-system/layouts/CommonLayout";

type MobileHeaderProps = {
  color?: string;
  className?: string;
};

export function MobileHeader({ color, className }: MobileHeaderProps) {
  const { currentLocaleCode } = useChangeLocaleCode();

  return (
    <header
      className={cn(
        "sticky top-0 z-[100] w-full xl:hidden",
        className,
      )}
      style={{
        backgroundColor: color || "#000C2C",
      }}
    >
      <div className="container flex items-center justify-between gap-4 py-4 lg:py-8">
        <Link to={URLS.home}>
          {currentLocaleCode === "en" ? (
            <LogoIcon className="max-lg:w-40" />
          ) : (
            <ArabicLogoIcon className="max-lg:w-40" />
          )}
        </Link>
        <div className="flex items-center gap-4">
          {/* <SearchButton /> */}
          <LinksDrawerButton />
        </div>
      </div>
      <SearchDrawer />
      <MobileLinksDrawer />
    </header>
  );
}
